
import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';

const CookiePolicyPage = () => {
  useEffect(() => {
    document.title = 'Çerez Politikası - LH Global Pass';
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-20">
        <section className="py-20">
          <div className="container mx-auto px-4 lg:px-8">
            <div className="max-w-4xl mx-auto">
              <h1 className="text-4xl lg:text-5xl font-bold text-navy mb-8">
                Çerez Politikası
              </h1>
              
              <div className="prose prose-lg max-w-none text-gray-700 leading-relaxed space-y-6">
                <p className="text-sm text-gray-500">Son Güncelleme: 01 Ocak 2025</p>

                <h2 className="text-2xl font-bold text-navy mt-8">1. Çerez Nedir?</h2>
                <p>
                  Çerezler, ziyaret ettiğiniz internet siteleri tarafından tarayıcılar aracılığıyla cihazınıza veya ağ sunucusuna depolanan küçük metin dosyalarıdır. LH Global Pass olarak, web sitemizde çeşitli amaçlarla çerezler kullanmaktayız.
                </p>

                <h2 className="text-2xl font-bold text-navy mt-8">2. Çerez Kullanım Amaçlarımız</h2>
                <p>
                  <strong>İzmir vize danışmanlığı</strong> web sitemizde çerezleri aşağıdaki amaçlarla kullanmaktayız:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Web sitesinin düzgün çalışmasını sağlamak</li>
                  <li>Kullanıcı deneyimini iyileştirmek</li>
                  <li>Web sitesi trafiğini analiz etmek</li>
                  <li>Güvenlik önlemlerini uygulamak</li>
                  <li>Tercihlerinizi hatırlamak</li>
                  <li>İçerik ve reklamları kişiselleştirmek</li>
                </ul>

                <h2 className="text-2xl font-bold text-navy mt-8">3. Kullandığımız Çerez Türleri</h2>
                
                <h3 className="text-xl font-semibold text-navy mt-6">3.1. Zorunlu Çerezler</h3>
                <p>
                  Bu çerezler, web sitesinin temel işlevlerini yerine getirmesi için gereklidir. Bu çerezler olmadan web sitesi düzgün çalışmayabilir. Zorunlu çerezler, oturum yönetimi, güvenlik ve erişilebilirlik gibi temel işlevleri sağlar.
                </p>

                <h3 className="text-xl font-semibold text-navy mt-6">3.2. Performans Çerezleri</h3>
                <p>
                  Bu çerezler, web sitesinin performansını ölçmemize ve iyileştirmemize yardımcı olur. Ziyaretçilerin web sitesini nasıl kullandığına dair anonim bilgiler toplar. Bu bilgiler, hangi sayfaların en çok ziyaret edildiğini ve kullanıcıların hata mesajları alıp almadığını anlamamıza yardımcı olur.
                </p>

                <h3 className="text-xl font-semibold text-navy mt-6">3.3. İşlevsellik Çerezleri</h3>
                <p>
                  Bu çerezler, web sitesinin gelişmiş özelliklerini ve kişiselleştirme seçeneklerini sağlar. Tercihlerinizi (dil seçimi, bölge gibi) hatırlamamıza ve size daha kişiselleştirilmiş bir deneyim sunmamıza olanak tanır.
                </p>

                <h3 className="text-xl font-semibold text-navy mt-6">3.4. Hedefleme/Reklam Çerezleri</h3>
                <p>
                  Bu çerezler, size ve ilgi alanlarınıza daha uygun reklamlar göstermek için kullanılır. Ayrıca, bir reklamın kaç kez gösterildiğini sınırlamak ve reklam kampanyalarının etkinliğini ölçmek için de kullanılabilir.
                </p>

                <h2 className="text-2xl font-bold text-navy mt-8">4. Üçüncü Taraf Çerezleri</h2>
                <p>
                  Web sitemizde, üçüncü taraf hizmet sağlayıcılar tarafından yerleştirilen çerezler de bulunabilir. Bu çerezler, analitik hizmetler, sosyal medya entegrasyonları ve reklam ağları gibi hizmetler için kullanılır. Üçüncü taraf çerezleri hakkında daha fazla bilgi için ilgili üçüncü tarafların gizlilik politikalarını incelemenizi öneririz.
                </p>

                <h2 className="text-2xl font-bold text-navy mt-8">5. Çerez Yönetimi</h2>
                <p>
                  Çoğu internet tarayıcısı, çerezleri otomatik olarak kabul edecek şekilde ayarlanmıştır. Ancak, tarayıcı ayarlarınızı değiştirerek çerezleri reddedebilir veya bir çerez gönderildiğinde sizi uyaracak şekilde ayarlayabilirsiniz.
                </p>
                <p>
                  Çerezleri nasıl yöneteceğiniz veya sileceğiniz hakkında daha fazla bilgi için tarayıcınızın yardım bölümüne bakabilirsiniz:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li><strong>Google Chrome:</strong> chrome://settings/cookies</li>
                  <li><strong>Mozilla Firefox:</strong> about:preferences#privacy</li>
                  <li><strong>Safari:</strong> Tercihler &gt; Gizlilik</li>
                  <li><strong>Microsoft Edge:</strong> edge://settings/privacy</li>
                </ul>
                <p>
                  Lütfen unutmayın ki, çerezleri devre dışı bırakmanız durumunda web sitemizin bazı özellikleri düzgün çalışmayabilir.
                </p>

                <h2 className="text-2xl font-bold text-navy mt-8">6. Çerez Politikası Güncellemeleri</h2>
                <p>
                  Bu Çerez Politikası, yasal düzenlemelerdeki değişiklikler veya web sitemizdeki güncellemeler nedeniyle zaman zaman güncellenebilir. Güncellemeler bu sayfada yayınlanacak ve "Son Güncelleme" tarihi değiştirilecektir. Düzenli olarak bu sayfayı ziyaret ederek güncel bilgilere ulaşabilirsiniz.
                </p>

                <h2 className="text-2xl font-bold text-navy mt-8">7. İletişim</h2>
                <p>
                  Çerez Politikamız hakkında sorularınız veya endişeleriniz varsa, lütfen bizimle iletişime geçin:
                  <br />
                  <strong>E-posta:</strong> lhglobalpass@gmail.com
                  <br />
                  <strong>Telefon:</strong> +90 542 267 11 71
                  <br />
                  <strong>Adres:</strong> Fevzi Paşa Mah. 847/1 Sk. No:8 Kat:4 Daire:4/405 Sağlık İş Hanı Konak/İzmir
                </p>

                <h2 className="text-2xl font-bold text-navy mt-8">8. KVKK Uyumu</h2>
                <p>
                  Çerezler aracılığıyla toplanan kişisel veriler, 6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") kapsamında işlenmektedir. Kişisel verilerinizin işlenmesi hakkında detaylı bilgi için <a href="/kvkk" className="text-gold hover:text-gold-dark underline">KVKK Aydınlatma Metni</a> sayfamızı ziyaret edebilirsiniz.
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default CookiePolicyPage;
